import React from 'react';
import FormField from './FormField';
const DwFormField = (props) => {
    const fieldDef = props.def[props.name];
    const requiredField = () => {
        return (fieldDef && fieldDef.mandatory) || props.requiredLabel || false;
    };
    if (props.type === 'phoneprefix') {
        const optionArray = [
            { value: '', label: 'Select' },
            ...['+1', '+39', '+44', '+49'].map((p) => ({ value: p, label: p })) // ridotto per brevità
        ];
        return (React.createElement(FormField, Object.assign({}, props, fieldDef, { type: "select", options: optionArray, required: fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.mandatory })));
    }
    return (React.createElement(FormField, Object.assign({}, props, fieldDef, { required: requiredField() })));
};
DwFormField.defaultProps = {
    type: 'text',
};
export default DwFormField;
